/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    SaveFromRemote,
    SaveFromRemoteResponse,
} from '../models';

export interface FileApiControllerSaveFromRemoteRequest {
    saveFromRemote: SaveFromRemote;
}

/**
 * 
 */
export class FileApi extends runtime.BaseAPI {

    /**
     */
    async fileApiControllerSaveFromRemoteRaw(requestParameters: FileApiControllerSaveFromRemoteRequest): Promise<runtime.ApiResponse<SaveFromRemoteResponse>> {
        if (requestParameters.saveFromRemote === null || requestParameters.saveFromRemote === undefined) {
            throw new runtime.RequiredError('saveFromRemote','Required parameter requestParameters.saveFromRemote was null or undefined when calling fileApiControllerSaveFromRemote.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/file:save-from-remote`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.saveFromRemote,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async fileApiControllerSaveFromRemote(requestParameters: FileApiControllerSaveFromRemoteRequest): Promise<SaveFromRemoteResponse> {
        const response = await this.fileApiControllerSaveFromRemoteRaw(requestParameters);
        return await response.value();
    }

}
